/**
 * Customer-facing ingredient label. Organic SKUs use a trailing marker so
 * names stay consistent with Shopify bulk titles (e.g. Ashwagandha (Organic)).
 */
export function displayIngredientName(name, quality) {
  const base = String(name || '').replace(/_/g, ' ').trim();
  if (!base) return '';
  if (quality === 'organic') {
    const lower = base.toLowerCase();
    if (lower.startsWith('organic ')) return `${base.slice(8).trim()} (Organic)`;
    if (lower.endsWith('(organic)')) return base;
    return `${base} (Organic)`;
  }
  return base;
}
